import React from 'react';
import { useProgressCalculation } from '../../../utils/performance';

const ProgressSection = ({ lines }) => {
  const progress = useProgressCalculation(lines);
  
  const additionalProgress = {
    needsVendor: lines.filter(l => !l.vendor_id && l.state !== 'completed').length,
    needsPrice: lines.filter(l => !l.price_unit && l.state !== 'completed').length,
    needsCert: lines.filter(l => !l.certification && l.state !== 'completed').length
  };

  return (
    <section className="progress-section" aria-labelledby="progress-heading">
      <h2 id="progress-heading" className="sr-only">Quote Progress</h2>
      <div className="progress-stats" role="group" aria-label="Progress statistics">
        <span>
          <strong>
            Progress: {progress.completed}/{progress.baseTotal} ({progress.percentage}%)
          </strong>
        </span>
        {additionalProgress.needsVendor > 0 && (
          <span className="needs-attention" role="alert">
            ⚠ {additionalProgress.needsVendor} need vendor
          </span>
        )}
        {additionalProgress.needsPrice > 0 && (
          <span className="needs-attention" role="alert">
            ⚠ {additionalProgress.needsPrice} need price
          </span>
        )}
        {additionalProgress.needsCert > 0 && (
          <span className="needs-attention" role="alert">
            ⚠ {additionalProgress.needsCert} need certification
          </span>
        )}
      </div>
      <div
        className="progress-bar"
        role="progressbar"
        aria-valuenow={progress.percentage}
        aria-valuemin="0"
        aria-valuemax="100"
        aria-label={`Quote completion progress: ${progress.percentage}%`}
      >
        <div className="progress-fill" style={{ width: `${Math.min(progress.percentage, 100)}%` }} />
      </div>
    </section>
  );
};

export default ProgressSection;